import { actionTypes } from '../../types';

// Action creator for requesting agency list by status
export const getAgencyListByStatus = (payload) => ({
    type: actionTypes.GET_AGENCY_LIST_BY_STATUS_REQUEST,
    payload,
});

// Action creator on success
export const getAgencyListByStatusSuccess = (payload) => ({
    type: actionTypes.GET_AGENCY_LIST_BY_STATUS_SUCCESS,
    payload,
});

// Action creator on failure
export const getAgencyListByStatusFailure = (payload) => ({
    type: actionTypes.GET_AGENCY_LIST_BY_STATUS_FAILURE,
    payload,
});

// Reset status/message only
export const getAgencyListByStatusReset = () => ({
    type: actionTypes.GET_AGENCY_LIST_BY_STATUS_RESET,
});

// Reset whole reducer to initial state
export const getAgencyListByStatusResetAll = () => ({
    type: actionTypes.GET_AGENCY_LIST_BY_STATUS_RESET_ALL,
});
